import axios from 'axios';
import { ROUTE_API } from 'configs';
import auth_service from './authService';
import { dispatch } from 'store';
import { hideLoading, showLoading } from 'store/slices/loading';
import { hideLoadingCursor, showLoadingCursor } from 'store/slices/loadingCursor';
import moment from 'moment';

const AxiosInstance = axios.create({
    baseURL: ROUTE_API.index,
    timeout: 100000
});
let requestCount: number = 0;
let cursorRequestCount: number = 0;
function decreaseRequestCount(): void {
    requestCount = requestCount - 1;
    if (requestCount === 0) {
        dispatch(hideLoading());
    }
}
function decreaseRequestCountCursor(): void {
    cursorRequestCount = cursorRequestCount - 1;
    if (cursorRequestCount === 0) {
        dispatch(hideLoadingCursor());
    }
}
function convertDatesToUTC(obj: any): any {
    if (obj && obj.hasOwnProperty("created_at")) {
        if (Array.isArray(obj.created_at) && obj.created_at.length === 2) {
            obj.created_at = obj.created_at.map((date:any) => moment(date).format("YYYY-MM-DD HH:mm:ss"));
        } 
        // else {
        //     if(obj.created_at){
        //         obj.created_at = moment(obj.created_at).format("YYYY-MM-DD HH:mm:ss");
        //     }
        // }
    }
    return obj;
}

AxiosInstance.interceptors.request.use(
    (config: any) => {
        const accessToken: string = auth_service.getAccessToken();
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        if (config.headers.isShowLoading) {
            requestCount++;
            dispatch(showLoading());
        }
        if (config.headers.cursorLoading) {
            cursorRequestCount++;
            dispatch(showLoadingCursor());
        }
        config.params = convertDatesToUTC(config.params);
        return config;
    },
    (err: any) => {
        if (err.config.headers.isShowLoading) {
            decreaseRequestCount();
        }
        if (err.config.headers.cursorLoading) {
            decreaseRequestCountCursor();
        }
        return Promise.reject(err);//.response
    }
);
AxiosInstance.interceptors.response.use(
    (res: any) => {
        if (res.config.headers.isShowLoading) {
            decreaseRequestCount();
        }
        if (res.config.headers.cursorLoading) {
            decreaseRequestCountCursor();
        }
        return res;
    },
    (err: any) => {
        if (err.config.headers.isShowLoading) {
            decreaseRequestCount();
        }
        if (err.config.headers.cursorLoading) {
            decreaseRequestCountCursor();
        }
        if (err.response?.status === 401) {
            window.localStorage.removeItem('accessToken');
        }
        return Promise.reject(err);//.response
    }
);

export default AxiosInstance;